document.addEventListener("DOMContentLoaded", () => {
  const initUGCSwiper = () => {
    if (typeof Swiper === "undefined") return;

    const swiperEl = document.querySelector(".ugcSwiper");
    if (!swiperEl || swiperEl.classList.contains("swiper-initialized")) return;

    new Swiper(".ugcSwiper", {
      slidesPerView: 1.2,
      spaceBetween: 12,
      freeMode: true,
      grabCursor: true,
      centeredSlides: false,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      breakpoints: {
        360: { slidesPerView: 1.2, spaceBetween: 15 },
        768: { slidesPerView: 2.2, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 20 },
      },
      preventClicks: false,
      preventClicksPropagation: false,
    });

    swiperEl.classList.add("swiper-initialized");
  };

  const bindHoverToVideos = () => {
    const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!isDesktop) return;

    document.querySelectorAll("video.video-ugc").forEach((video) => {
      if (video.dataset.hoverBound === "true") return;
      video.dataset.hoverBound = "true";

      video.muted = true;

      video.addEventListener("mouseenter", () => {
        if (video.readyState >= 2) {
          video.currentTime = 0;
          video.play();
        }
      });

      video.addEventListener("mouseleave", () => {
        video.pause();
        video.currentTime = 0;

        const src = video.querySelector("source")?.src;
        const poster = video.getAttribute("poster");
        const imgTag = video.querySelector("img");
        let inner = `<source src="${src}" type="video/mp4">`;
        if (imgTag) {
          inner += imgTag.outerHTML;
        }
        video.innerHTML = inner;
        video.setAttribute("poster", poster);
        video.load();
      });
    });
  };

  const observer = new MutationObserver(() => {
    initUGCSwiper();
    bindHoverToVideos();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  initUGCSwiper();
  bindHoverToVideos();

  const slider = document.querySelector(".ugc-videos-swiper");
  const slides = document.querySelectorAll(".ugc-videos-wrapper .swiper-slide");
  const dotsContainer = document.querySelector(".ugc-dots");

  if (!slider || !slides.length || !dotsContainer) return;

  slides.forEach((_, index) => {
    const dot = document.createElement("div");
    dot.classList.add("ugc-dot");
    if (index === 0) dot.classList.add("active");

    dot.addEventListener("click", () => {
      const slideWidth = slides[0].offsetWidth + 12;
      slider.scrollTo({
        left: slideWidth * index,
        behavior: "smooth",
      });
    });

    dotsContainer.appendChild(dot);
  });

  const dots = document.querySelectorAll(".ugc-dot");

  slider.addEventListener("scroll", () => {
    const slideWidth = slides[0].offsetWidth + 12;
    const index = Math.round(slider.scrollLeft / slideWidth);

    dots.forEach((dot) => dot.classList.remove("active"));
    if (dots[index]) dots[index].classList.add("active");
  });
});

const slider = document.querySelector(".ugc-videos-swiper");

let startX = 0;
let startY = 0;
let isScrolling = false;

slider.addEventListener("pointerdown", (evt) => {
  const container = evt.target.closest(".ugc-video-container");
  if (!container) return;

  startX = evt.clientX;
  startY = evt.clientY;
  isScrolling = false;
});

slider.addEventListener("pointermove", (evt) => {
  const dx = Math.abs(evt.clientX - startX);
  const dy = Math.abs(evt.clientY - startY);

  if (dx > 10 || dy > 10) {
    isScrolling = true;
  }
});

slider.addEventListener("pointerup", (evt) => {
  const container = evt.target.closest(".ugc-video-container");
  if (!container) return;

  if (isScrolling) return;

  const video = container.querySelector("video.video-ugc");
  if (!video) return;

  const source =
    video.querySelector("source")?.src || video.currentSrc || "";
  const poster = video.getAttribute("poster") || "";

  const modal = document.createElement("div");
  modal.className = "ugc-modal";
  modal.innerHTML = `
    <div class="ugc-modal-content">
      <button class="ugc-modal-close">x</button>
      <video class="ugc-modal-video" controls playsinline poster="${poster}">
        <source src="${source}" type="video/mp4">
      </video>
    </div>
  `;

  document.body.appendChild(modal);
  document.body.style.overflow = "hidden";

  const modalVideo = modal.querySelector("video");
  modalVideo.play().catch(() => {
    modalVideo.muted = true;
    modalVideo.play().catch(() => { });
  });

  const closeModal = () => {
    modal.remove();
    document.body.style.overflow = "";
  };

  modal.querySelector(".ugc-modal-close").addEventListener("click", closeModal);
  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });
});

const items = document.querySelectorAll('.swiper-slide-video');

const observer = new IntersectionObserver(entries => {
  entries.forEach((entry, index) => {
    if (entry.isIntersecting) {
      setTimeout(() => {
        entry.target.classList.add('show');
      }, index * 150);
    }
  });
});

items.forEach(el => observer.observe(el));
